
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
export default [
  {
    name: "model-grade-id",
    path: "/model-grade/:id()",
    component: () => import("/var/www/catalog/app/pages/model-grade/[id].vue")
  },
  {
    name: "model-top-id",
    path: "/model-top/:id()",
    component: () => import("/var/www/catalog/app/pages/model-top/[id].vue")
  },
  {
    name: "body-type-selection",
    path: "/body-type-selection",
    component: () => import("/var/www/catalog/app/pages/body-type-selection/index.vue")
  },
  {
    name: "brand-selection",
    path: "/brand-selection",
    component: () => import("/var/www/catalog/app/pages/brand-selection/index.vue")
  },
  {
    name: "car-model-list",
    path: "/car-model-list",
    component: () => import("/var/www/catalog/app/pages/car-model-list/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/catalog/app/pages/index.vue")
  }
]